import { defineStore } from 'pinia';
import { InteractionModeEnum, getActionByString } from '@/types/InteractionModeEnum';
import {
  getEditToken,
  prolongEditToken,
  freeEditToken,
  requestEditToken,
} from '@/services/interactionModeService';

export const useInteractionModeStore = defineStore('InteractionModeStore', {
  state: () => ({
    mode: undefined as InteractionModeEnum | undefined,
    editToken: undefined as EditTokenType | undefined,
  }),

  getters: {
    getMode(state) {
      return state.mode;
    },
    getEditToken(state) {
      return state.editToken;
    },
  },

  actions: {
    setMode(mode: string | undefined) {
      mode = getActionByString(mode as string);
      if (mode) {
        this.mode = mode as InteractionModeEnum;
      }
    },

    async requestEditMode() {
      this.editToken = (await requestEditToken()) || undefined;
    },

    async prolongEditMode() {
      this.editToken = (await prolongEditToken()) || undefined;
    },

    async leaveEditMode() {
      await freeEditToken();
      this.editToken = undefined;
    },

    async fetchEditToken() {
      this.editToken = (await getEditToken()) || undefined;
    },
  },
});
